import {ENV_CONFIG} from '../../../../env-config';

export const environment = {
  origin: '',
  production: true,
  timeStamp: '6/27/2021 - 8:55:00 PM',
  firebase: ENV_CONFIG.firebase,
  firebaseEmulators: false
};
